// Filename: collections/activitys
define('collections/conversation/custom-messages',[
    'underscore',
    'backbone',
    'mustache',
    'moment',
    'utils',
    'services/api',
    // super class
    'src/plugins/infinite-collection',
    // Pull in the Model module from above
    'models/conversation/custom-message'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // src
    API,
    // super class
    InfiniteCollection,
    // model
    MCustomMessage
) {

    var CCustomMessages = InfiniteCollection.extend({
        model: MCustomMessage,
        url: API.url("custom-messages/"),
        //Sort the custom Message by title
      comparator: function(a, b) {
          return a.get('title') > b.get('title');
      },
    });

    return CCustomMessages;
});

